import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

const TextAreaEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const editorRef = useRef(null);

  useEffect(() => {
    const stopNavigation = event => {
      if ([13, 32, 37, 38, 39, 40, 36, 35].indexOf(event.keyCode) > -1) {
        event.stopPropagation();
      }
    };

    const editor = editorRef.current;

    editor.addEventListener('keydown', stopNavigation);

    return () => {
      editor.removeEventListener('keydown', stopNavigation);
    };
  }, []);

  const handleChange = event => {
    setValue(event.target.value);
  };

  useImperativeHandle(ref, () => ({
    getValue: () => value,
    isPopup: () => false,
    afterGuiAttached: () => {
      editorRef.current.select();
    },
  }));

  return <textarea ref={editorRef} onChange={handleChange} placeholder="Input..." value={value} />;
});

export default TextAreaEditor;
